exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".login .error{padding:13px 50px 13px 15px;border-radius:5px;border:1px solid #ecacb4;background:#f8dade;max-width:800px;margin:15px auto -45px;display:block;position:relative;margin-bottom:5px;text-align:left}.login .error p{font-size:14px;color:#dd485b;line-height:1.2;max-width:100%;margin:0}.login .error p span{display:block;margin-top:5px;font-weight:600}.login .error a{position:absolute;right:15px;top:50%;margin-top:-9px;width:18px;height:18px}.login .error a:before{transform:rotate(45deg)}.login .error a:after,.login .error a:before{content:\"\";position:absolute;display:block;width:2px;height:25px;background:#b0b5bc;left:9px;top:-3px}.login .error a:after{transform:rotate(-45deg)}.login .error.active{display:block}.login .wrapper-main .container .left-side form input[type=submit]{margin-top:20px}.login .wrapper-main .container .right-side{height:inherit}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./components/home/login/login.css
// module id = 561
// module chunks = 0